function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1600",
  height: "1600",
  viewBox: "0 0 1200 1200",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1133.3 382.22H66.6c-36.445 0-66.668-30.223-66.668-66.668 0-36.445 30.223-66.664 66.668-66.664h1066.7c36.445 0 66.668 30.223 66.668 66.668 0 36.445-30.223 66.668-66.668 66.668zM953.78 666.67H246.23c-36.445 0-66.668-30.223-66.668-66.668s30.223-66.668 66.668-66.668h708.45c36.445 0 66.668 30.223 66.668 66.668s-30.223 66.668-66.668 66.668zM731.55 951.11h-264c-36.445 0-66.668-30.223-66.668-66.668 0-36.445 30.223-66.668 66.668-66.668h264c36.445 0 66.668 30.223 66.668 66.668 0 36.445-30.223 66.668-66.668 66.668z"
}))));